<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<div class="row container-general">
					<div class="col-3 content-left">
						<div class="card card-custom gutter-b">
							<!--begin::Body-->
							<div class="card-body">
								<!--begin::Wrapper-->
								<div class="d-flex justify-content-between flex-column h-100">
									<!--begin::Container-->
									<div class="h-100">
										<!--begin::Header-->
										<div class="d-flex flex-column flex-center">
											<!--begin::Image-->
											<!-- Logo + botón editar -->
											<div class="position-relative w-100 rounded min-h-180px bg-white">
												<!-- Contenido (logo o placeholder) -->
												<ng-container *ngIf="reseller?.logoFile && reseller.logoFile.length > 0; else noLogo">
													<div
													class="bgi-no-repeat bgi-size-contain rounded min-h-180px w-100 h-100"
													[style.background-image]="'url(data:image/jpeg;base64,' + reseller.logoFile + ')'"
													style="background-position:center; background-size:contain;">
													</div>
												</ng-container>

												<!-- Placeholder cuando no hay logo -->
												<ng-template #noLogo>
													<div class="d-flex align-items-center justify-content-center rounded min-h-180px w-100 h-100 bg-light">
													<fa-icon icon="image" class="fa-3x text-muted"></fa-icon>
													</div>
												</ng-template>

												<!-- Botón lápiz SIEMPRE visible -->
												<button type="button"
														class="btn btn-clean btn-icon btn-sm position-absolute shadow-sm"
														style="top:6px; left:6px; background: rgba(255,255,255,.95); border-radius: 50%;"
														ngbTooltip="Actualizar logo"
														(click)="logoInput.click()">
													<fa-icon icon="pen"></fa-icon>
												</button>
												<!-- Input file oculto -->
												<input #logoInput type="file" accept="image/*" class="d-none" (change)="onLogoSelected($event)">
											</div>
											<!--end::Image-->
											<!--begin::Title-->
											<a href="#" class="card-title font-weight-bolder text-dark-75 text-hover-primary font-size-h4 m-0 pt-7 pb-1">{{ reseller.razonSocial }}</a>
											<!--end::Title-->
											<!--begin::Text-->
											<div class="font-weight-bold text-dark-50 font-size-sm mt-4 pb-1">{{ reseller.domicilio }}</div>
											<div class="font-weight-bold text-dark-50 font-size-sm pb-3">{{ reseller.comuna }}</div>
											<!--end::Text-->
											<!--begin::Text-->
											<div class="font-weight-bold text-dark-50 font-size-sm pb-6">{{ reseller.emailContacto }}</div>

											<div *ngIf="resumenReseller" class="font-weight-bold text-dark-50 font-size-h3">Partner nivel {{ resumenReseller.nivelPartner }}</div>
											<div *ngIf="resumenReseller" class="font-weight-bold text-dark-50 font-size-sm pb-6">{{ resumenReseller.descuentoPartner }}% de descuento</div>
											<!--end::Text-->
										</div>
										<!--end::Header-->
									</div>
									<!--begin::Body-->
									<div class="pt-1">
										<!--begin::Item-->
										<div class="d-flex align-items-center pb-9">
											<!--begin::Symbol-->
											<div class="symbol symbol-30 symbol-light mr-4">
												<span class="symbol-label">
													<span class="svg-icon svg-icon-dark-50">
														<!--begin::Svg Icon | path:assets/media/svg/icons/Media/Equalizer.svg-->
														<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
															<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																<rect x="0" y="0" width="24" height="24" />
																<rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
																<rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
																<rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
																<rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
															</g>
														</svg>
														<!--end::Svg Icon-->
													</span>
												</span>
											</div>
											<!--end::Symbol-->
											<!--begin::Text-->
											<div class="d-flex flex-column flex-grow-1">
												<a href="#" class="text-dark-75 text-hover-primary mb-1 font-size-lg font-weight-bolder">Total Planes</a>
												<span class="text-muted font-weight-bold">Cálculo fijo + IVA</span>
											</div>
											<!--end::Text-->
											<!--begin::label-->
											<span *ngIf="resumenReseller" class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px">{{ resumenReseller.totalPlanes | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
											<span *ngIf="!resumenReseller" class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px">Cargando</span>
											<!--end::label-->
										</div>
										<!--end::Item-->
										<!--begin::Item-->
										<div class="d-flex align-items-center pb-9">
											<!--begin::Symbol-->
											<div class="symbol symbol-30 symbol-light mr-4">
												<span class="symbol-label">
													<span class="svg-icon svg-icon-dark-50">
														<!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Group.svg-->
														<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
															<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																<polygon points="0 0 24 0 24 24 0 24" />
																<path d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
																<path
																	d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
																	fill="#000000"
																	fill-rule="nonzero" />
															</g>
														</svg>
														<!--end::Svg Icon-->
													</span>
												</span>
											</div>
											<!--end::Symbol-->
											<!--begin::Text-->
											<div class="d-flex flex-column flex-grow-1">
												<a href="#" class="text-dark-75 text-hover-primary mb-1 font-size-lg font-weight-bolder">Total Adicionales</a>
												<span class="text-muted font-weight-bold">De este mes</span>
											</div>
											<!--end::Text-->
											<!--begin::label-->
											<span *ngIf="resumenReseller" class="font-weight-bolder label label-xl label-light-danger label-inline px-3 py-5 min-w-45px">{{ resumenReseller.totalAdicionales | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
											<span *ngIf="!resumenReseller" class="font-weight-bolder label label-xl label-light-danger label-inline px-3 py-5 min-w-45px">$0</span>
											<!--end::label-->
										</div>
										<!--end::Item-->
										<!--begin::Item-->
										<!-- <div class="d-flex align-items-center pb-9">
											<div class="symbol symbol-30 symbol-light mr-4">
												<span class="symbol-label">
													<span class="svg-icon svg-icon-dark-50">
														<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
															<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																<polygon points="0 0 24 0 24 24 0 24" />
																<path d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
																<path
																	d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
																	fill="#000000"
																	fill-rule="nonzero" />
															</g>
														</svg>
													</span>
												</span>
											</div>
											<div class="d-flex flex-column flex-grow-1">
												<a href="#" class="text-dark-75 text-hover-primary mb-1 font-size-lg font-weight-bolder">Total Pendiente</a>
												<span class="text-muted font-weight-bold">Saldo moroso</span>
											</div>
											<span *ngIf="resumenReseller" class="font-weight-bolder label label-xl label-light-danger label-inline px-3 py-5 min-w-45px">{{ resumenReseller.totalMoroso }}</span>
											<span *ngIf="!resumenReseller" class="font-weight-bolder label label-xl label-light-danger label-inline px-3 py-5 min-w-45px">$0</span>
										</div> -->
										<!--end::Item-->
										<!--begin::Item-->
										<div class="d-flex align-items-center pb-9">
											<!--begin::Symbol-->
											<div class="symbol symbol-30 symbol-light mr-4">
												<span class="symbol-label">
													<span class="svg-icon svg-icon-dark-50">
														<!--begin::Svg Icon | path:assets/media/svg/icons/Home/Globe.svg-->
														<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
															<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																<rect x="0" y="0" width="24" height="24" />
																<path
																	d="M13,18.9450712 L13,20 L14,20 C15.1045695,20 16,20.8954305 16,22 L8,22 C8,20.8954305 8.8954305,20 10,20 L11,20 L11,18.9448245 C9.02872877,18.7261967 7.20827378,17.866394 5.79372555,16.5182701 L4.73856106,17.6741866 C4.36621808,18.0820826 3.73370941,18.110904 3.32581341,17.7385611 C2.9179174,17.3662181 2.88909597,16.7337094 3.26143894,16.3258134 L5.04940685,14.367122 C5.46150313,13.9156769 6.17860937,13.9363085 6.56406875,14.4106998 C7.88623094,16.037907 9.86320756,17 12,17 C15.8659932,17 19,13.8659932 19,10 C19,7.73468744 17.9175842,5.65198725 16.1214335,4.34123851 C15.6753081,4.01567657 15.5775721,3.39010038 15.903134,2.94397499 C16.228696,2.49784959 16.8542722,2.4001136 17.3003976,2.72567554 C19.6071362,4.40902808 21,7.08906798 21,10 C21,14.6325537 17.4999505,18.4476269 13,18.9450712 Z"
																	fill="#000000"
																	fill-rule="nonzero" />
																<circle fill="#000000" opacity="0.3" cx="12" cy="10" r="6" />
															</g>
														</svg>
														<!--end::Svg Icon-->
													</span>
												</span>
											</div>
											<!--end::Symbol-->
											<!--begin::Text-->
											<div class="d-flex flex-column flex-grow-1">
												<a href="#" (click)="obtenerPDF()" class="text-dark-75 text-hover-primary mb-1 font-size-lg font-weight-bolder">Última Factura</a>
												<span class="text-muted font-weight-bold">Revisa los detalles</span>
											</div>
											<!--end::Text-->
											<!--begin::label-->
											<span *ngIf="resumenReseller && ultimaFactura" class="font-weight-bolder label label-xl label-light-primary label-inline py-5 min-w-45px">{{ ultimaFactura.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
											<span *ngIf="!resumenReseller" class="font-weight-bolder label label-xl label-light-primary label-inline py-5 min-w-45px">$0</span>
											<!--end::label-->
										</div>
										<!--end::Item-->
									</div>
									<!--end::Body-->
									<!--eng::Container-->
									<!--begin::Footer-->
									<div class="d-flex flex-center" id="kt_sticky_toolbar_chat_toggler_2" data-toggle="tooltip" title="" data-placement="right" data-original-title="Chat Example">
										<button class="btn btn-primary font-weight-bolder font-size-sm py-3 px-14" data-toggle="modal" data-target="#kt_chat_modal">Detalles</button>
									</div>
									<!--end::Footer-->
								</div>
								<!--end::Wrapper-->
							</div>
							<!--end::Body-->
						</div>
					</div>
					<div class="col-9 content-right">
						<div class="card card-custom gutter-bs">
							<div class="card-header card-header-tabs-line">
								<div class="card-toolbar">
									<!--begin::Tabs-->
									<ul class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-primary mt-3 px-8" role="tablist">
										<li class="nav-item">
											<a class="nav-link cursor-pointer" data-toggle="tab" (click)="setActiveTabId('planes')" [ngClass]="getActiveCSSClasses('planes')">Planes de Empresas</a>
										</li>
										<li class="nav-item">
											<a class="nav-link cursor-pointer" data-toggle="tab" (click)="setActiveTabId('facturas')" [ngClass]="getActiveCSSClasses('facturas')">Facturas Emitidas</a>
										</li>
										<li class="nav-item">
											<a class="nav-link cursor-pointer" data-toggle="tab" (click)="setActiveTabId('certificaciones')" [ngClass]="getActiveCSSClasses('certificaciones')">Solicitar Certificaciones</a>
										</li>
									</ul>
									<!--end::Tabs-->
								</div>
							</div>
							<div class="tab-content">
								<div class="tab-pane p-8" id="planes" role="tabpanel" [ngClass]="getActiveCSSClasses('planes')">
									<div class="card card-custom gutter-b">
										<div class="card-header">
											<div class="card-title">
												<span class="card-icon">
													<i class="fa-duotone fa-handshake text-primary"></i>
												</span>
												<h3 class="card-label">Planes contratados<small> Aquí encuentras toda la información de tus clientes</small></h3>
											</div>
											<div class="card-toolbar">
												<ng-select class="comboPeriodo" [clearable]="false" placeholder="Seleccione Período" bindLabel="label" bindValue="label" [items]="periodos" [(ngModel)]="periodo" (change)="onPeriodChange($event)"> </ng-select>
											</div>
										</div>
										<div class="card-body">
											<ngx-datatable
												#tablaPlanes
												*ngIf="componentStarted"
												class="material mobile-hidden"
												[rows]="rowsPlanesMantenedor"
												[columnMode]="'flex'"
												[headerHeight]="50"
												[footerHeight]="50"
												[rowHeight]="100"
												fxFlex="auto"
												[externalPaging]="true"
												[count]="pagePlanes.totalElements"
												[offset]="pagePlanes.pageNumber"
												[limit]="pagePlanes.pageSize"
												(page)="setPagePlanes($event)"
												(sort)="utilities.onSortTable(tablaPlanes, pagePlanes)"
												[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
												[externalSorting]="false"
												[sortType]="SortType.multi">
												<ngx-datatable-column [width]="60" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
													<ng-template let-value="row.logo" ngx-datatable-cell-template>
														<div class="symbol-2 flex-center">
															<div class="symbol-label-2" [style.background-image]="'url(data:image/jpeg;base64,' + value + ')'"></div>
														</div>
													</ng-template>
												</ngx-datatable-column>

												<ngx-datatable-column name="RazonSocial" [flexGrow]="5" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Razón Social</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment text-wrap">{{ row.razonSocial }}</span></ng-template
													>
												</ngx-datatable-column>
												<ngx-datatable-column name="FechaInicio" [flexGrow]="2.5" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Fecha de inicio</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment">{{ row.fechaContratacion | date : "dd/MM/yyyy"}}</span>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-column name="FechaInicio" [flexGrow]="3" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Fecha de termino</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment">{{ row.fechaTermino | date : "dd/MM/yyyy"}}</span>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-column name="Ciudad" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Usuarios</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment">{{ row.totalUsuarios }} / {{ row.maxUsuarios }}</span>
													</ng-template>
												</ngx-datatable-column>
												<!-- <ngx-datatable-column name="Ciudad" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Total BHE</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment">{{ row.totalBHEEmitidos }} / {{ row.maxBHE | number }}</span>
													</ng-template>
												</ngx-datatable-column> -->
												<ngx-datatable-column name="Ciudad" [flexGrow]="2.5" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Total DTE</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment" *ngIf="row.maxDTE != -1">{{ row.totalDTEEmitidos }} / {{ row.maxDTE | number : "1.0-0" }}</span>
														<span class="text-table-alignment" *ngIf="row.maxDTE == -1">{{ row.totalDTEEmitidos }} / Ilimitado</span>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-column name="Plan" [flexGrow]="2.5" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Plan</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row">
														<div>
															<a href="#" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{ row.nombrePlan }}</a>
															<span class="text-muted font-weight-bold d-block">{{ row.precioPlan | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
														</div>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-column [flexGrow]="1.5" [sortable]="false" [resizeable]="false">
													<ng-template ngx-datatable-cell-template let-row="row">
														<div ngbDropdown class="dropdownBotoneraLinea" container="body">
															<a ngbDropdownToggle id="dropdownConfig" container="body" [routerLink]="" class="success edit mr-1 mrless" ngbTooltip="Configuración">
																<div class="icon-circle bg-success text-center align-middle pt-info-button">
																	<!-- <i class="fa-duotone fa-gears text-white"></i> no pesca la clase -->
																	<fa-icon icon="cog" class="fa-lg text-white"></fa-icon>
																</div>
															</a>

															<div ngbDropdownMenu aria-labelledby="dropdownConfig">
																<button ngbDropdownItem (click)="cambiarPlan(modalCambioPlan, row)">Nuevo Plan</button>
																<button ngbDropdownItem (click)="cancelarPlan(row.planUsuarioId)">Dar de Baja</button>
															</div>
														</div>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-footer>
													<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
														<div class="col-auto">Elementos por página</div>
														<div class="mr-5">
															<ng-select [(ngModel)]="pagePlanes.pageSize" [items]="pagePlanes.pageSizes" [clearable]="false" (change)="setPageSizePlanes()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
																<option *ngFor="let option of pagePlanes.pageSizes" [value]="option"></option>
															</ng-select>
														</div>
														<div class="ml-5 col-auto divisor-footer">
															<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
														</div>
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tablaPlanes.onFooterPage($event)"> </datatable-pager>
													</ng-template>
												</ngx-datatable-footer>
											</ngx-datatable>

											<!--Tabla movil-->
											<ngx-datatable
												#tableMobile
												*ngIf="activeTabId === 'planes' && componentStarted"
												class="material desktop-hidden"
												[rows]="rowsPlanesMantenedor"
												[perfectScrollbar]="configScroll"
												[columnMode]="'flex'"
												[headerHeight]="50"
												[footerHeight]="70"
												[rowHeight]="80"
												fxFlex="auto"
												[externalPaging]="true"
												[count]="pagePlanes.totalElements"
												[offset]="pagePlanes.pageNumber"
												[limit]="pagePlanes.pageSize"
												(page)="setPagePlanes($event)"
												(sort)="utilities.onSortTable(tablaPlanes, pagePlanes)"
												[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
												[externalSorting]="false"
												[sortType]="SortType.multi">

												<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
													<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
														<div class="text-wrap">
															Cliente: {{ row.razonSocial }}, 
															Usuarios: {{ row.totalUsuarios }} / {{ row.maxUsuarios }}, 
															Total DTE:
															<span *ngIf="row.maxDTE != -1">
																{{ row.totalDTEEmitidos }} / {{ row.maxDTE | number : "1.0-0" }}
															</span>
															<span  *ngIf="row.maxDTE == -1">
																{{ row.totalDTEEmitidos }} / Ilimitado
															</span>,
															Plan: {{ row.nombrePlan }} - {{ row.precioPlan | currency : "$ " : "symbol" : "1.0-0" : "es" }}
														 </div>
													</ng-template>
												</ngx-datatable-row-detail>
		
												<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
													<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
														<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
													</ng-template>
												</ngx-datatable-column>
												
												<ngx-datatable-column name="RazonSocial" [flexGrow]="6" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Razón Social</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment text-wrap text-movil">{{ row.razonSocial }}</span></ng-template
													>
												</ngx-datatable-column>
												<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
													<ng-template ngx-datatable-cell-template let-row="row">
														<div ngbDropdown class="dropdownBotoneraLinea" container="body">
															<a ngbDropdownToggle id="dropdownConfig" container="body" [routerLink]="" class="success edit mr-1 mrless" ngbTooltip="Configuración">
																<div class="icon-circle bg-success text-center align-middle pt-info-button">
																	<!-- <i class="fa-duotone fa-gears text-white"></i> no pesca la clase -->
																	<fa-icon icon="cog" class="fa-lg text-white"></fa-icon>
																</div>
															</a>

															<div ngbDropdownMenu aria-labelledby="dropdownConfig" class="planes-partner">
																<button ngbDropdownItem (click)="cambiarPlan(modalCambioPlan, row)">Nuevo Plan</button>
																<button ngbDropdownItem (click)="cancelarPlan(row.planUsuarioId)">Dar de Baja</button>
															</div>
														</div>
													</ng-template>
												</ngx-datatable-column>
												
												<ngx-datatable-footer>
													<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
														<div class="row" style="width: 100%">
															<div class="col-12 mb-2 ml-3 text-center mt-2">
																<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
															</div>
															<div class="col-12 d-flex justify-content-center">
																<span class="mr-2 mt-3">Elementos por página</span>

																<ng-select [(ngModel)]="pagePlanes.pageSize" [items]="pagePlanes.pageSizes" [clearable]="false" (change)="setPageSizePlanes()" dropdownPosition="top" style="overflow: visible" appendTo="body">
																	<option *ngFor="let option of pagePlanes.pageSizes" [value]="option"></option>
																</ng-select>
																<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
															</div>
														</div>
													</ng-template>
												</ngx-datatable-footer>
											</ngx-datatable>
											<!--Fin Tabla movil-->
										</div>
									</div>
								</div>
								<div class="tab-pane p-8" id="facturas" role="tabpanel" [ngClass]="getActiveCSSClasses('facturas')">
									<div class="card card-custom gutter-b">
										<div class="card-header">
											<div class="card-title">
												<span class="card-icon">
													<i class="fa-duotone fa-handshake text-primary"></i>
												</span>
												<h3 class="card-label">Facturas emitidas<small> Puedes revisar el detalle de cada una</small></h3>
											</div>
											<div class="card-toolbar">
												<!-- <ng-select class="comboPeriodo" [clearable]="false" placeholder="Seleccione Período" bindLabel="label" bindValue="label" [items]="periodos" [(ngModel)]="periodo" (change)="onPeriodChange($event)"> </ng-select> -->
											</div>
										</div>
										<div class="card-body">
											<ngx-datatable
												#tablaFacturas
												*ngIf="componentStarted"
												class="material mobile-hidden"
												[rows]="rowsFacturasMantenedor"
												[columnMode]="'flex'"
												[headerHeight]="50"
												[footerHeight]="50"
												[rowHeight]="80"
												fxFlex="auto"
												[externalPaging]="true"
												[count]="pageFacturas.totalElements"
												[offset]="pageFacturas.pageNumber"
												[limit]="pageFacturas.pageSize"
												(page)="setPageFacturas($event)"
												(sort)="utilities.onSortTable(tablaFacturas, pageFacturas)"
												[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
												[externalSorting]="false"
												[sortType]="SortType.multi">
												<ngx-datatable-column name="Folio" [flexGrow]="1" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Folio</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment text-wrap">{{ row.folio }}</span></ng-template
													>
												</ngx-datatable-column>
												<ngx-datatable-column name="RazonSocial" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Razon Social</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment text-wrap">{{ reseller.razonSocial }}</span></ng-template
													>
												</ngx-datatable-column>
												<ngx-datatable-column name="FechaEmision" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Fecha Emisión</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment">{{ row.fechaEmision | date : "dd/MM/y" }}</span>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-column name="Total" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Total</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment">{{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-column [flexGrow]="1" [sortable]="false" [resizeable]="false">
													<ng-template ngx-datatable-cell-template let-row="row">
														<div ngbDropdown class="dropdownBotoneraLinea" container="body">
															<a [routerLink]="" (click)="openPDF(row.facturaId)" title="Descarga Documento" ngbTooltip="Descarga Documento" class="success edit mr-1 mrless">
																<div class="icon-circle bg-danger text-center align-middle pt-file-button">
																	<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
																</div>
															</a>
														</div>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-footer>
													<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
														<div class="col-auto">Elementos por página</div>
														<div class="mr-5">
															<ng-select [(ngModel)]="pageFacturas.pageSize" [items]="pageFacturas.pageSizes" [clearable]="false" (change)="setPageSizeFacturas()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
																<option *ngFor="let option of pageFacturas.pageSizes" [value]="option"></option>
															</ng-select>
														</div>
														<div class="ml-5 col-auto divisor-footer">
															<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
														</div>
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tablaFacturas.onFooterPage($event)"> </datatable-pager>
													</ng-template>
												</ngx-datatable-footer>
											</ngx-datatable>
											
											<!--Tabla movil-->
											<ngx-datatable
												#tableMobile
												*ngIf="activeTabId === 'facturas' && componentStarted"
												class="material desktop-hidden"
												[rows]="rowsFacturasMantenedor"
												[columnMode]="'flex'"
												[perfectScrollbar]="configScroll"
												[headerHeight]="50"
												[footerHeight]="70"
												[rowHeight]="80"
												fxFlex="auto"
												[externalPaging]="true"
												[count]="pageFacturas.totalElements"
												[offset]="pageFacturas.pageNumber"
												[limit]="pageFacturas.pageSize"
												(page)="setPageFacturas($event)"
												(sort)="utilities.onSortTable(tablaFacturas, pageFacturas)"
												[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
												[externalSorting]="false"
												[sortType]="SortType.multi">

												<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
													<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
														<div class="text-wrap">
															Folio: {{ row.folio }},
															Razón Social: {{ reseller.razonSocial }},
															Fecha Emisión: {{ row.fechaEmision | date : "dd/MM/y" }},
															Total: {{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}
														 </div>
													</ng-template>
												</ngx-datatable-row-detail>
		
												<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
													<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
														<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
													</ng-template>
												</ngx-datatable-column>
												

												<ngx-datatable-column name="Folio" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Folio</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment text-wrap text-movil">{{ row.folio }}</span></ng-template
													>
												</ngx-datatable-column>
												<ngx-datatable-column name="RazonSocial" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
													<ng-template let-column="column" ngx-datatable-header-template>
														<span class="text-table-alignment">Razon Social</span>
													</ng-template>
													<ng-template ngx-datatable-cell-template let-row="row"
														><span class="text-table-alignment text-wrap text-movil">{{ reseller.razonSocial }}</span></ng-template
													>
												</ngx-datatable-column>
												<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
													<ng-template ngx-datatable-cell-template let-row="row">
														<div ngbDropdown class="dropdownBotoneraLinea" container="body">
															<a [routerLink]="" (click)="openPDF(row.facturaId)" title="Descarga Documento" ngbTooltip="Descarga Documento" class="success edit mr-1 mrless">
																<div class="icon-circle bg-danger text-center align-middle pt-file-button">
																	<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
																</div>
															</a>
														</div>
													</ng-template>
												</ngx-datatable-column>
												<ngx-datatable-footer>
													<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
														<div class="row" style="width: 100%">
															<div class="col-12 mb-2 ml-3 text-center mt-2">
																<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
															</div>
															<div class="col-12 d-flex justify-content-center">
																<span class="mr-2 mt-3">Elementos por página</span>

																<ng-select [(ngModel)]="pagePlanes.pageSize" [items]="pagePlanes.pageSizes" [clearable]="false" (change)="setPageSizePlanes()" dropdownPosition="top" style="overflow: visible" appendTo="body">
																	<option *ngFor="let option of pagePlanes.pageSizes" [value]="option"></option>
																</ng-select>
																<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
															</div>
														</div>
													</ng-template>
												</ngx-datatable-footer>
											</ngx-datatable>
										</div>
									</div>
								</div>
								<div class="tab-pane p-8" id="certificaciones" role="tabpanel" [ngClass]="getActiveCSSClasses('certificaciones')">
									<div class="card card-custom gutter-b">
										<div class="card-header">
											<div class="card-title">
												<span class="card-icon">
													<i class="fa-duotone fa-certificate text-primary"></i>
												</span>
												<h3 class="card-label">Solicitar certificaciones<small> Selecciona una empresa y las certificaciones que necesites</small></h3>
											</div>
											<div class="card-toolbar">
												<ng-select class="comboEmpresa" [items]="rowsPlanesMantenedor" [clearable]="true" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="empresaCertSeleccionada" (change)="onEmpresaCertificacionChange()"></ng-select>
											</div>
										</div>
										<div class="card-body">
											<div *ngIf="!empresaCertSeleccionada" class="text-center py-5">
												<i class="fa-duotone fa-building fa-3x text-muted mb-3"></i>
												<p class="text-muted mb-0">Selecciona una empresa para ver y solicitar certificaciones.</p>
											</div>

											<div *ngIf="empresaCertSeleccionada">
												<h6 class="font-weight-bold mb-3">Certificaciones de {{ empresaCertSeleccionada.razonSocial }}</h6>

												<div *ngIf="!certificacionesTabLoaded" class="text-center py-4">
													<div class="spinner-border text-primary" role="status"></div>
													<p class="text-muted mt-2">Cargando certificaciones...</p>
												</div>

												<div *ngIf="certificacionesTabLoaded">
													<div *ngIf="certificacionesTab.length; else sinCertificacionesPartner">
														<div class="card card-custom shadow-none border mb-5">
															<div class="table-responsive">
																<table class="table table-hover mb-0 pf-cert-table">
																	<thead class="thead-light">
																		<tr>
																			<th>Fecha solicitud</th>
																			<th>Tipo</th>
																			<th>Código SII</th>
																			<th>Estado</th>
																			<th>Fecha Ult. Actualización</th>
																			<th class="text-center">Acciones</th>
																		</tr>
																	</thead>
																	<tbody>
																		<tr *ngFor="let cert of certificacionesTab">
																			<td>
																				<span *ngIf="cert.fechaSolicitud; else sinFechaSolicitudPartner">{{ cert.fechaSolicitud | date:'dd/MM/yyyy' }}</span>
																				<ng-template #sinFechaSolicitudPartner><span class="text-muted">Sin registro</span></ng-template>
																			</td>
																			<td class="font-weight-bold">{{ cert.nombreCertificacion }}</td>
																			<td>{{ cert.codigoSii }}</td>
																			<td>
																				<span class="badge" [ngClass]="getCertEstadoClass(cert.estadoId)">{{ cert.estadoNombre }}</span>
																			</td>
																			<td>
																				<span *ngIf="cert.fechaFinalizacion; else sinFechaFinPartner">{{ cert.fechaFinalizacion | date:'dd/MM/yyyy' }}</span>
																				<ng-template #sinFechaFinPartner><span class="badge badge-light-secondary">{{ cert.fechaSolicitud | date:'dd/MM/yyyy' }}</span></ng-template>
																			</td>
																			<td class="text-center">
																				<ng-container *ngIf="puedeGestionarInstructivo(cert); else sinAccionInstructivoPartner">
																					<button class="btn btn-icon btn-sm btn-outline-primary mr-1" ngbTooltip="Descargar instructivo" (click)="descargarInstructivo(cert)">
																						<i class="fa-regular fa-download"></i>
																					</button>
																					<button class="btn btn-icon btn-sm btn-outline-info" ngbTooltip="Reenviar instructivo" (click)="reenviarInstructivo(cert)">
																						<i class="fa-regular fa-paper-plane"></i>
																					</button>
																				</ng-container>
																				<ng-template #sinAccionInstructivoPartner><span class="text-muted">No disponible</span></ng-template>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</div>
														</div>
													</div>
													<ng-template #sinCertificacionesPartner>
														<div class="text-center py-4">
															<i class="fa-duotone fa-certificate fa-3x text-muted mb-3"></i>
															<p class="text-muted mb-0">Esta empresa no tiene certificaciones registradas.</p>
														</div>
													</ng-template>
												</div>

												<hr class="my-5">

												<div class="d-flex justify-content-between align-items-center mb-3">
													<p class="mr-2 m-0 font-weight-bold">Solicitar nueva certificación</p>
													<small class="text-muted">Las certificaciones deshabilitadas ya cuentan con folios o tienen certificaciones pendientes/realizadas</small>
												</div>

												<div *ngIf="!certificacionesDisponiblesLoaded" class="text-center py-4">
													<div class="spinner-border text-primary" role="status"></div>
												</div>

												<div *ngIf="certificacionesDisponiblesLoaded">
													<div class="card border-width-3 border-radius-0 border-color-hover-dark mb-3">
														<div class="card-body">
															<div *ngIf="certificacionesDisponibles?.length; else emptyCertsPartner">
																<div *ngFor="let cert of certificacionesDisponibles" class="d-flex align-items-center py-2 border-bottom">
																	<div class="custom-control custom-checkbox mr-3">
																		<input type="checkbox" class="custom-control-input" [id]="'certpartner-' + cert.codigoPrincipal" [checked]="cert.solicitada" [disabled]="cert.disabled || solicitandoCertificaciones" (change)="toggleCertificacionDisponible(cert)"/>
																		<label class="custom-control-label" [for]="'certpartner-' + cert.codigoPrincipal"></label>
																	</div>
																	<div class="flex-grow-1"><strong>{{ cert.nombre }}</strong></div>
																	<div class="text-right font-weight-bold" style="min-width:120px">$ {{ cert.valor | number:'1.0-0':'es' }}</div>
																</div>
															</div>
															<ng-template #emptyCertsPartner><div class="text-muted">No hay certificaciones disponibles para esta empresa.</div></ng-template>
														</div>
													</div>

													<div class="d-flex justify-content-between align-items-center flex-wrap">
														<div>
															<span class="font-weight-bold">Total a facturar en tu próxima liquidación: </span>
															<span class="font-weight-bolder label label-lg label-light-primary label-inline px-3">$ {{ totalCertificacionesSeleccionadas | number:'1.0-0':'es' }}</span>
															<small class="text-muted d-block mt-1">No se realiza cobro ahora; el monto se incluirá en la liquidación mensual del partner.</small>
														</div>
														<button type="button" class="btn btn-primary" [disabled]="!hayCertificacionesParaSolicitar || solicitandoCertificaciones" (click)="solicitarCertificacionesSeleccionadas()">
															<span *ngIf="!solicitandoCertificaciones"><i class="fa-regular fa-certificate mr-1"></i> Solicitar certificaciones seleccionadas</span>
															<span *ngIf="solicitandoCertificaciones"><span class="spinner-border spinner-border-sm mr-1"></span> Solicitando...</span>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--begin::Panel Principal-->
			</div>
		</div>
	</div>
</div>

<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
<ng-template #modalCambioPlan>
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Cambio de Plan</div>
				<div class="modal-wizard-desc">Seleccione según corresponda</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row mt-4 content-modal">
				<div class="col-8">
					<app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'change'" [planSeleccionado]="planSeleccionado" [planUsuario]="planActual" (actualizarPlan)="updatePlan($event)"></app-planes-bloque>
				</div>
				<div class="col-4">
					<div class="card-body card border-width-3 border-radius-0 border-color-hover-dark">
						<p *ngIf="planOriginal">
							La empresa {{ currentEmisor.razonSocial }} tiene actualmente el plan <b>{{ planOriginal.nombre }}</b
							>.
						</p>
						<p *ngIf="planSeleccionado && planSeleccionado.id != planOriginal.id">
							El nuevo plan comanzará a regir desde el próximo mes, es decir, <b>{{ nombreProximoMes }}</b
							>, y a fin de ese mes se te cobrará según tu nuevo plan y tu descuento de partner.
						</p>
						<p *ngIf="planSeleccionado && planSeleccionado.id != planOriginal.id">
							Tu plan actual: <b>{{ planOriginal.maxDte | number : "1." }}</b> DTEs.
						</p>
						<p *ngIf="planSeleccionado && planSeleccionado.id != planOriginal.id">
							Nuevo plan: <b>{{ planSeleccionado.maxDte | number : "1." }}</b> DTEs. {{ planSeleccionado.precio | currency : "$" : "symbol" : "1.0-0" : "es" }} + IVA.
						</p>
						<p *ngIf="planSeleccionado && planSeleccionado.id != planOriginal.id">
							<label for="planAhora"> <input id="planAhora" type="checkbox" class="me-2" name="planAhora" [checked]="planAhora" (change)="updatePlanAhora($event)" /> Deseo que el plan empiece desde ahora </label>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div style="display: flex; align-items: center; flex-flow: row">
				<!-- <small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el pago.</small> -->
				<button type="button" class="btn ml-4 btn-primary" (click)="procederCambioPlan()">Cambiar plan</button>
				<button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button>
			</div>
		</div>
	</div>
</ng-template>
